import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MockService } from 'app/modules/vehicle-inventory/services/mock-service';
import { ConfirmationService, SelectItem } from 'primeng/api';

import { RestVehicleInventory } from 'app/modules/vehicle-inventory/services/rest_vehicle-inventory';
import { DriverInfoCardComponent } from '../driver/driver-info-card/driver-info-card.component';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { I18nService } from 'app/services/i18n/i18n.service';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { ZonegroupService } from 'app/rest/zonegroup.service';
import { Rest } from 'app/rest/rest_client';
import { DriverService } from 'app/modules/vehicle-inventory/services/driver.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "app/services/excel-service/excel.service";
import { InvVehicleService } from 'app/modules/vehicle-inventory/services/invVehicle.service';
import { VehicleService } from 'app/rest/vehicle.service';

@Component({
    selector: 'app-drivers-table',
    templateUrl: './drivers-table.component.html',
    styleUrls: ['./drivers-table.component.css'],
    standalone: false
})
export class DriversTableComponent extends EntityListComponent<Rest.InvDriver> implements OnInit {
    title: string = "Drivers";

    @ViewChild(DriverInfoCardComponent, { static: true }) driverForm: DriverInfoCardComponent;

    user: Rest.User;
    EnabledFilter: SelectItem[];

    // PERMISSIONS
    isCreateGranted: boolean = false;
    isFormGranted: boolean = false;
    isDisabledGranted: boolean = false;
    columnsCount: number;


    constructor(
        protected driverService: DriverService,
        protected confirmationService: ConfirmationService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
        protected excelService: ExcelService,
        protected translateService: TranslateService,
    ) {
        super(
            driverService,
            confirmationService,
            notificationsService,
            i18n,
            authenticationService,
            loadingService,
            userTime,
            excelService
        );

        this.driverService = driverService;

    }

    ngOnInit() {
        super.ngOnInit();
        this.form = this.driverForm;
        /*Permissions */
        this.user = this.authenticationService.user;
        /** */

        this.setPermissions();
        this.setColumns();
    }


    beforeLoad() {
        if (this.paginationRequest.filters.hasOwnProperty("disabled")) {
            this.paginationRequest.filters["disabled"] = this.paginationRequest.filters["disabled"][0].toString() == "true" ? ["false"] : ["true"];
        }
    }

    setPermissions() {
        const user = this.authenticationService.user;
        const rolesForForm = ['INV_DRIVER_READ', 'INV_DRIVER_UPDATE'];

        this.isCreateGranted = this.authenticationService.isRoleGranted('INV_DRIVER_CREATE', user);
        this.isDisabledGranted = this.authenticationService.isRoleGranted('INV_DRIVER_DISABLE', user);
        this.isFormGranted = this.authenticationService.isOneRoleGranted(rolesForForm, user);
    }

    editDialog(event) {
        if (!this.isFormGranted) {
            return;
        }

        if (!this.isSelectableColumn) {
            this.onRowDblClick({ data: event });
        }
        this.isSelectableColumn = false;
        this.isColumn = true;
    }

    excelColumns = {};

    exportExcel() {
        //	this.setExcelColumns();
            let fileNameTitle = this.translateService.instant('drivers.table.title');
        //super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
            super.exportExcelWithColumnsMetadata(fileNameTitle, this.selectedColumns);
        }

    

    setColumns() {
		let headerValue = '';
		this.columns = [];

        this.columns.push({
            field: 'code',
            header: this.translateService.instant('drivers.table.code'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>entity.employee?.code ?? ''
        });

        this.columns.push({
            field: 'fullName',
            header: this.translateService.instant('drivers.table.name'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>`${entity.employee?.user?.surname1 ?? ''} ${entity.employee?.user?.surname2 ?? ''},  ${entity.employee.user?.name ?? ''}`
        });

        const birthDate = (entity: any) => {
			const datestring= entity.employee?.user?.birthDate ?? '';
			 if (datestring !='')
		 {
				const date = new Date(datestring);
				if (!isNaN(date.getTime())) {
					//const date = new Date(datestring);
					date.setHours(0, 0, 0, 0); // Forzar las horas a 00:00:00 en la zona local
					return date;
				}
			}
			return null;
	   };
	   this.columns.push({
			field: 'birthDate',
			header: this.translateService.instant('drivers.table.birthDate'),
			type: 'date',
			excel: true,
			bindField: birthDate,
			excelType: 'd',
			excelFormat: 'dd/mm/yyyy',
		});

        
        this.columns.push({
            field: 'userName',
            header: this.translateService.instant('drivers.table.nif'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>entity.employee?.nif ?? ''
        });

        const nifExpirationDate = (entity: any) => {
			const datestring= entity.employee?.nifExpirationDate ?? '';
			 if (datestring !='')
		 {
				const date = new Date(datestring);
				if (!isNaN(date.getTime())) {
					//const date = new Date(datestring);
					date.setHours(0, 0, 0, 0); // Forzar las horas a 00:00:00 en la zona local
					return date;
				}
			}
			return null;
	   };
	   this.columns.push({
			field: 'nifExpirationDate',
			header: this.translateService.instant('drivers.table.expirationDateNif'),
			type: 'date',
			excel: true,
			bindField: nifExpirationDate,
			excelType: 'd',
			excelFormat: 'dd/mm/yyyy',
		});

        const expeditionDate = (entity: any) => {
			const datestring= entity.licenseData?.[0]?.expeditionDate ?? '';
			 if (datestring !='')
		 {
				const date = new Date(datestring);
				if (!isNaN(date.getTime())) {
					//const date = new Date(datestring);
					date.setHours(0, 0, 0, 0); // Forzar las horas a 00:00:00 en la zona local
					return date;
				}
			}
			return null;
	   };
	   this.columns.push({
			field: 'expeditionDate',
			header: this.translateService.instant('drivers.table.expeditionDateLicense'),
			type: 'date',
			excel: true,
			bindField: expeditionDate,
			excelType: 'd',
			excelFormat: 'dd/mm/yyyy',
		});

        const expirationDate = (entity: any) => {
			const datestring= entity.licenseData?.[0]?.expirationDate ?? '';
			 if (datestring !='')
		 {
				const date = new Date(datestring);
				if (!isNaN(date.getTime())) {
					//const date = new Date(datestring);
					date.setHours(0, 0, 0, 0); // Forzar las horas a 00:00:00 en la zona local
					return date;
				}
			}
			return null;
	   };
	   this.columns.push({
			field: 'expirationDate',
			header: this.translateService.instant('drivers.table.expirationDateLicense'),
			type: 'date',
			excel: true,
			bindField: expirationDate,
			excelType: 'd',
			excelFormat: 'dd/mm/yyyy',
		});

        this.columns.push({
            field: 'observations',
            header: this.translateService.instant('drivers.table.observations'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>entity.employee?.observations ?? ''
        });

        this.columns.push({
            field: 'divisionCode',
            header: this.translateService.instant('drivers.table.divisionCode'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>entity.employee.subdivision?.division?.code ?? ''
        });

        this.columns.push({
            field: 'division',
            header: this.translateService.instant('drivers.table.division'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>entity.employee?.subdivision?.division?.name ?? ''
        });

        this.columns.push({
            field: 'subDivisionCode',
            header: this.translateService.instant('drivers.table.subdivisionCode'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>entity.employee?.subdivision?.code ?? ''
        });

        this.columns.push({
            field: 'subDivision',
            header: this.translateService.instant('drivers.table.subdivision'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>entity.employee?.subdivision?.name ?? ''
        });

        this.columns.push({
            field: 'companyCode',
            header: this.translateService.instant('drivers.table.companyCode'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>entity.employee?.ceco?.billingAccount?.code ?? ''
        });

        this.columns.push({
            field: 'company',
            header: this.translateService.instant('drivers.table.company'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>entity.employee?.ceco?.billingAccount?.name ?? ''
        });

        this.columns.push({
            field: 'cecoCode',
            header: this.translateService.instant('drivers.table.cecoCode'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>entity.employee?.ceco?.code ?? ''
        });

        this.columns.push({
            field: 'ceco',
            header: this.translateService.instant('drivers.table.ceco'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>entity.employee?.ceco?.description ?? ''
        });

        this.columns.push({
            field: 'erp',
            header: this.translateService.instant('drivers.table.importERP'),
            type: 'string',
            excel: true,
            bindField: (entity: any) =>entity.employee?.importERP ? "Si" : "No"
        });

        this.columns.push({
			field: 'disabled',
			header: this.translateService.instant('general.disabled'),
			type: 'boolean',
			excel: true,
			excelType: 'b',
			bindField: (entity: any) => entity.disabled ?? ''
		});



		this.columnsCount = this.columns.length;
		this.selectedColumns = this.columns;
		super.mapSelectedColumns();
	}



}
